import React from "react";
import {Spin} from "antd";
import i18n from "./../../i18n";

export default function Spinner({children, loading, label = i18n.t('main.loadText.loading'), size = 'large'}) {
  return (
    <Spin spinning={loading} tip={label} size={size} style={{paddingTop: "100px", textAlign: "center"}}>
      {(children) ? children : <div/>}
    </Spin>
  );
}
